<template>
  <div>
    <!-- 关联商品 -->
    <div class="common-form mt50">关联设置</div>
      <el-form-item size="small" label="关联商品">
        <el-button icon="el-icon-plus" @click="changeProduct(form.tableData)">选择关联商品</el-button>
        <div class="pb50">
          <el-table size="small" :data="form.tableData" border>
            <el-table-column label="图片" width="60">
              <template slot-scope="scope">
                <div class="product-info">
                  <div class="pic">
                    <img width="30px" height="30px" v-img-url="scope.row.product_image" alt="product_image"/></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="product_name" label="商品"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="deleteClick(scope.$index)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>



      

      <!-- <div class="pb50" >
          <div class="user">
          <div class="product-content">
            <el-form ref="form" size="small" :model="form" label-width="150px">

              <el-form-item label="选择优惠券 " prop="name" :rules="[{ required: true, message: ' ' }]">

                  <el-table size="small" :data="form.coupon_ids" border>
                    <el-table-column prop="coupon_id" label="优惠券Id">
        
                    </el-table-column>
                    <el-table-column prop="name" label="优惠券名称"></el-table-column>


                  </el-table>

                <el-button @click="openConpon" icon="el-icon-plus">选择优惠券</el-button>

              </el-form-item>
            </el-form>

   
          <GetCoupon v-if="open_coupon" :excludeIds='coupon_excludeIds' :islist='islist' :open_add="open_coupon" @closeDialog="closeCouponFunc($event, 'add')"></GetCoupon>
            
          </div>
        </div>
      </div> -->
    <!--商品选择-->
    <Product :isproduct="isproduct" :excludeIds="excludeIds" :islist="true" @closeDialog="closeDialogFunc"></Product>

  </div>
</template>

<script>
import Product from '@/components/product/Product';
import {mergeTable} from '@/utils/table.js';
import GetCoupon from '@/components/coupon/GetCoupons.vue';
export default {
  components: {
    /*选择商品组件*/
    Product,
    GetCoupon,
  },
  data() {
    return {
      unit: '%',
      isproduct: false,
      /*产品去重*/
      excludeIds: [],
      coupon_excludeIds:[],
      /*是否显示获取优惠券*/
      open_coupon: false,
      islist:true,
    };
  },
  props: {
    form: Object,
    type: String
  },
  methods: {
      /*选择优惠券*/
    openConpon() {
      this.open_coupon = true;
    },

        /*关闭优惠券*/
    closeCouponFunc(e) {
      console.log('e',e);
      this.open_coupon = false;
      if (e.type != 'error') {
        this.form.coupon_ids = e.params;
      }
      console.log(' this.form.coupon_ids', this.form.coupon_ids);
      
     
    },
    /*关闭弹窗*/
    /*关闭弹窗*/
    closeDialogFunc(e) {
      console.log(e)
      let self = this;
      self.isproduct = false;
      if (e.type === 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          let obj = {
            product_name: item.product_name,
            product_id: item.product_id,
            product_price: item.product_price,
            product_image: item.product_image
          };
          arr.push(obj);
        }
        self.form.tableData = self.form.tableData.concat(arr);
        self.form.tableData = mergeTable(this.form.tableData);
      }
    },
    /*打开添加*/
    changeProduct(list) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.product_id);
      });
      this.excludeIds = arr;
      this.isproduct = true;
    },
    /*删除商品*/
    deleteClick(e) {
      let curItem = this.form.tableData[e];
      for (let i = 0; i < this.form.tableData.length; i++) {
        let item = this.form.tableData[i];
        if (curItem.product_id == item.product_id) {
          if (this.type == 'edit' && e.tempProduct != true) {
            let product_id = item.product_id;
            this.form.product_del_ids.push(product_id);
          }
          this.form.tableData.splice(i, 1);
          i--;
        }
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/Relationproduct.vue